/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AtSign({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#AtSign_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M2.1 8a5.9 5.9 0 0 1 11.8 0c0 .687-.091 1.277-.325 1.68-.2.345-.537.609-1.242.609a.747.747 0 0 1-.602-.263c-.142-.168-.242-.43-.242-.762V5.111a.6.6 0 1 0-1.2 0v.256a3.489 3.489 0 1 0 .255 5.021 1.946 1.946 0 0 0 1.79 1.1c1.1 0 1.847-.464 2.278-1.205.399-.685.488-1.54.488-2.283a7.1 7.1 0 1 0-3.944 6.362.6.6 0 1 0-.534-1.075A5.9 5.9 0 0 1 2.1 8ZM8 5.711a2.289 2.289 0 1 0 0 4.578A2.289 2.289 0 0 0 8 5.71Z" clipRule="evenodd" /></g><defs><clipPath id="AtSign_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;